export * from './doctor.type';
export * from './doctor-medical-entity.type';
